import useGetLocker from "./useGetLocker";

export const VIRTUAL_CONTEXTLESS_DROPOFF_FLAG = "virtual_contextless_dropoff";

export const isVirtualContextlessDropoffEnabled = (
  locker?: Pick<Locker, "flags"> | null
) => Boolean(locker?.flags?.includes(VIRTUAL_CONTEXTLESS_DROPOFF_FLAG));

export function useVirtualContextlessDropoff() {
  const lockerQuery = useGetLocker({ refetchOnMount: false });

  return {
    enabled: isVirtualContextlessDropoffEnabled(lockerQuery.data),
    lockerQuery,
  };
}

export default useVirtualContextlessDropoff;
